import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import coin from "assets/images/singhCoinCurrency.png";
import colors from "assets/theme-dark/base/colors";
import { useNavigate } from "react-router-dom";

function EarnedCards({ color, icon, title, description, value, route }) {
  let navigate = useNavigate();
  const { black, singh, singhGrey } = colors;

  const handleRoute = () => {
    navigate(`${route}`);
  };

  return (
    <Card
      onClick={() => handleRoute()}
      sx={{
        cursor: "pointer",
        backgroundColor: `${black.main}`,
        "&:hover": {
          outline: `1px solid ${singh.main}`,
        },
      }}
    >
      <MDBox p={2} mx={3} display="flex" justifyContent="center">
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          // bgColor={color}
          color="white"
          width="3rem"
          height="3rem"
          // shadow="md"
          // borderRadius="lg"
          // variant="gradient"
          sx={{
            background: "linear-gradient(195deg, #20201e, #f7cb19)",
            borderRadius: "1.5rem",
          }}
        >
          {/* <Icon fontSize="default">{icon}</Icon> */}
          {icon}
        </MDBox>
      </MDBox>
      <MDBox pb={2} px={2} textAlign="center" lineHeight={1.25}>
        <MDTypography
          variant="h6"
          fontWeight="medium"
          textTransform="capitalize"
        >
          {title}
        </MDTypography>
        {/* {description && ( */}
        <MDTypography variant="caption" color="text" fontWeight="regular">
          {description}
        </MDTypography>
        {/* )} */}
        {/* {description && !value ? null : <Divider />} */}
        <Divider />
        {/* {value && ( */}
        <MDTypography
          variant="h5"
          fontWeight="medium"
          overflow="hidden"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
        >
          <img src={coin} height="25px" />
          {value % 1 === 0 ? value : value.toFixed(3)}
        </MDTypography>
        {/* )} */}
      </MDBox>
    </Card>
  );
}

// Setting default values for the props of DefaultInfoCard
EarnedCards.defaultProps = {
  color: "info",
  value: "",
  description: "",
};

// Typechecking props for the DefaultInfoCard
EarnedCards.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
  ]),
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default EarnedCards;
